/* NĒM FAQ chat. Questions come from the section blocks, serialised into
   the #hs-chat-data JSON script tag, so the client edits them in the editor. */
(function () {
  'use strict';

  var launcher = document.getElementById('hs-chat-btn');
  var box = document.getElementById('hs-chat-box');
  var closeBtn = document.getElementById('hs-close');
  var content = document.getElementById('hs-chat-content');
  var options = document.getElementById('hs-options');
  var dataTag = document.getElementById('hs-chat-data');

  if (!launcher || !box || !closeBtn || !content || !options || !dataTag) return;

  var data;
  try {
    data = JSON.parse(dataTag.textContent);
  } catch (err) {
    return;
  }

  var questions = data.questions || [];
  var TYPING_MS = 650;

  content.addEventListener(
    'wheel',
    function (event) {
      content.scrollTop += event.deltaY;
      event.stopPropagation();
    },
    { passive: true }
  );

  function renderQuestions() {
    options.innerHTML = '';
    questions.forEach(function (item) {
      if (!item.q) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = item.q;
      button.addEventListener('click', function () {
        handleQuestion(item);
      });
      options.appendChild(button);
    });
  }

  function appendBubble(text, who) {
    var bubble = document.createElement('div');
    bubble.className = 'hs-bubble ' + (who === 'user' ? 'user' : 'bot');
    if (who === 'bot') {
      bubble.innerHTML = text;
    } else {
      bubble.textContent = text;
    }
    content.appendChild(bubble);
    content.scrollTop = content.scrollHeight;
    return bubble;
  }

  function showTyping() {
    var typing = document.createElement('div');
    typing.className = 'hs-typing';
    typing.textContent = data.typing || '...';
    content.appendChild(typing);
    content.scrollTop = content.scrollHeight;
    return typing;
  }

  function handleQuestion(item) {
    appendBubble(item.q, 'user');
    var typing = showTyping();

    window.setTimeout(function () {
      typing.remove();
      appendBubble(item.a, 'bot');

      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'hs-back-btn';
      back.textContent = data.back || '';
      back.addEventListener('click', function () {
        back.remove();
        content.scrollTop = 0;
      });

      content.appendChild(back);
      content.scrollTop = content.scrollHeight;
    }, TYPING_MS);
  }

  function open() {
    box.hidden = false;
    box.style.display = 'flex';
    box.classList.add('hs-glow');
    launcher.setAttribute('aria-expanded', 'true');
    closeBtn.focus({ preventScroll: true });
  }

  function close() {
    box.style.display = 'none';
    box.hidden = true;
    box.classList.remove('hs-glow');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus({ preventScroll: true });
  }

  launcher.addEventListener('click', open);
  launcher.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      open();
    }
  });

  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !box.hidden) close();
  });

  renderQuestions();
})();
